import apiFactory from "./api";

const api = apiFactory({
  onError: (error) => console.log("API call error: ", error),
});

export default api;
